import Reveal from "@/components/base/Reveal";
import { director } from "@/mocks/about";

export default function Greeting() {
  return (
    <section id="greeting" className="scroll-mt-24 bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-content px-5 md:px-8">
        <div className="grid items-start gap-10 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-5">
            <div className="aspect-[4/5] w-full overflow-hidden rounded-2xl">
              <img
                src={director.image}
                alt={`${director.name} 원장 프로필 이미지`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="mt-5 rounded-2xl border border-background-200 bg-background-100/70 p-6">
              <h3 className="font-heading text-xl font-black text-foreground-950">
                {director.name}
              </h3>
              <p className="mt-1 text-sm font-bold text-primary-600">{director.role}</p>
              <p className="mt-2 font-label text-xs text-foreground-600">{director.intro}</p>
            </div>
          </Reveal>

          <Reveal delay={100} className="lg:col-span-7">
            <span className="font-label text-xs tracking-[0.25em] text-primary-600">
              DIRECTOR'S GREETING
            </span>
            <h2 className="mt-3 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              이름값 하는 수학,
              <br />
              성적으로 증명하겠습니다
            </h2>

            <div className="mt-7 space-y-5">
              {director.message.map((paragraph) => (
                <p
                  key={paragraph}
                  className="text-base leading-relaxed text-foreground-700"
                >
                  {paragraph}
                </p>
              ))}
            </div>

            <div className="mt-9 grid grid-cols-3 gap-3">
              {director.highlights.map((h) => (
                <div
                  key={h.label}
                  className="rounded-2xl bg-primary-500 p-5 text-center text-foreground-950"
                >
                  <p className="font-heading text-2xl font-black md:text-3xl">{h.value}</p>
                  <p className="mt-1 text-xs font-bold">{h.label}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}